import { get, patch } from "../../lib/fetch"
import type { GetCompliancesResponse, UpdateComplianceInput  } from "@montatec/contracts"

export const compliancesService = {
    get:    async () => await get<GetCompliancesResponse>(`/api/providers/compliance`).then(res => res.data),
    update: async (id: number, data: UpdateComplianceInput) => await patch(`/api/providers/compliance/${id}`, data),    
}